// extracted by mini-css-extract-plugin
export default {"root":"SectionHero_root__zeQDy","heroLogo":"SectionHero_heroLogo__SGvY6","microReassurance":"SectionHero_microReassurance__sD5OI"};